require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-introduction-to-logistic-regression.json") })
        }
      }, "path---posts-introduction-to-logistic-regression");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-introduction-to-logistic-regression!./.cache/json/posts-introduction-to-logistic-regression.json
// module id = 386
// module chunks = 231608221292675